import { render, staticRenderFns } from "./forgotPasswordMobile.vue?vue&type=template&id=b0bb2d38&"
import script from "./forgotPasswordMobile.vue?vue&type=script&lang=js&"
export * from "./forgotPasswordMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports